module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 11-3f5b62b351c96e9f31b0cf48f25c6bf7.jpg";